import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 space-y-3"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "absolute inset-x-0 bottom-3 flex items-center justify-between px-3 text-stone-200 text-xs" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "relative z-10 max-w-5xl w-full" }
const _hoisted_9 = ["src"]

import { SanityImage } from "@/types/sanityImageType";
import { computed, ref } from "vue";
import { getImageUrl } from "@/sanityClient";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectImageGallery',
  props: {
    images: {}
  },
  setup(__props: any) {

const props = __props;

const imageList = computed(() => props.images || []);
const currentIndex = ref(0);

const hasPrev = computed(() => currentIndex.value > 0);
const hasNext = computed(() => currentIndex.value < imageList.value.length - 1);

const currentImage = computed(() => imageList.value[currentIndex.value]);

const next = () => {
  if (hasNext.value) currentIndex.value += 1;
};

const prev = () => {
  if (hasPrev.value) currentIndex.value -= 1;
};

const selectedImage = ref<SanityImage | null>(null);

const openModal = (image?: SanityImage) => {
  if (!image) return;
  selectedImage.value = image;
  document.body.style.overflow = "hidden";
};

const closeModal = () => {
  selectedImage.value = null;
  document.body.style.overflow = "";
};

return (_ctx: any,_cache: any) => {
  return (imageList.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "relative aspect-video overflow-hidden rounded-lg bg-stone-100 dark:bg-stone-800 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal(currentImage.value)))
        }, [
          _createElementVNode("img", {
            src: _unref(getImageUrl)(currentImage.value),
            alt: `Project image ${currentIndex.value + 1}`,
            class: "w-full h-full object-cover"
          }, null, 8, _hoisted_2),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "hover:text-white transition-colors disabled:opacity-40",
              type: "button",
              onClick: _withModifiers(prev, ["stop"]),
              disabled: !hasPrev.value
            }, " ‹ Prev ", 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-[11px] uppercase tracking-[0.18em]" }, "Screens", -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (img, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: img._id || i,
                    class: _normalizeClass(["h-1.5 w-1.5 rounded-full transition-colors", i === currentIndex.value ? 'bg-white' : 'bg-white/40'])
                  }, null, 2))
                }), 128))
              ])
            ]),
            _createElementVNode("button", {
              class: "hover:text-white transition-colors disabled:opacity-40",
              type: "button",
              onClick: _withModifiers(next, ["stop"]),
              disabled: !hasNext.value
            }, " Next › ", 8, _hoisted_7)
          ])
        ]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode(_Transition, { name: "modal" }, {
            default: _withCtx(() => [
              (selectedImage.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fixed inset-0 z-50 flex items-center justify-center p-4",
                    onClick: closeModal
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute inset-0 bg-stone-950/90 backdrop-blur-sm" }, null, -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "absolute -top-12 right-0 text-stone-400 hover:text-stone-200 transition-colors",
                        onClick: closeModal
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("svg", {
                          class: "w-8 h-8",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "1.5",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))]),
                      _createElementVNode("img", {
                        src: _unref(getImageUrl)(selectedImage.value),
                        alt: "Enlarged project image",
                        class: "w-full h-auto max-h-[85vh] object-contain rounded-lg",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8, _hoisted_9)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      ]))
    : _createCommentVNode("", true)
}
}

})